export const WINDOW_LOAD = "WINDOW_LOAD";




// WEBPACK FOOTER //
// ./modules/Common/actions/windowEvents.js